import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api, API, imageUrl } from "@/lib/api";

const ROTATE_MS = 7000;
const HOUSE = {
  regional: { id: "house-regional", house: true, business_name: "Markdowns", image_src: "/banner-house-regional.jpg" },
  national: { id: "house-national", house: true, business_name: "Markdowns", image_src: "/banner-house-national.jpg" },
};

export default function BannerStrip({ placement }) {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  const seen = useRef(new Set());
  useEffect(() => {
    const house = placement === "HQ" ? HOUSE.national : HOUSE.regional;
    Promise.all([api.get("/banners/live", { params: { placement } }), api.get("/banners/pricing")])
      .then(([live, pr]) => setItems(live.data.length < (pr.data.max_rotation || 5) ? [...live.data, house] : live.data))
      .catch(() => setItems([house]));
  }, [placement]);
  useEffect(() => {
    if (items.length < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), ROTATE_MS);
    return () => clearInterval(t);
  }, [items]);
  const b = items[i];
  useEffect(() => {
    if (b && !b.house && !seen.current.has(b.id)) {
      seen.current.add(b.id);
      api.post(`/banners/${b.id}/view`, null, { params: { placement } }).catch(() => {});
    }
  }, [b, placement]);
  if (!b) return null;
  const img = <img src={b.house ? b.image_src : imageUrl(b.image_path)} alt={b.business_name} className="w-full aspect-[4/1] object-cover" data-testid={b.house ? "banner-house" : "banner-image"} />;
  const linked = b.house
    ? <Link to="/advertise" data-testid="banner-advertise-cta">{img}</Link>
    : b.link_url ? <a href={`${API}/banners/${b.id}/click?placement=${encodeURIComponent(placement)}`} target="_blank" rel="noopener sponsored" data-testid="banner-link">{img}</a> : img;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6" data-testid="banner-strip">
      <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-sm bg-white">
        {linked}
        {b.message && <div className="absolute left-3 bottom-3 max-w-[80%] bg-black/65 text-white text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-lg" data-testid="banner-message">{b.message}</div>}
        <div className="absolute top-2 right-2 flex items-center gap-1.5">
          {items.length > 1 && <div className="flex gap-1">{items.map((x, k) => <span key={x.id} className={`w-1.5 h-1.5 rounded-full ${k === i ? "bg-white" : "bg-white/50"}`} />)}</div>}
          <Link to="/advertise" className="text-[10px] uppercase tracking-widest font-black bg-white/90 text-slate-700 px-2 py-0.5 rounded-full" data-testid="banner-sponsored">Sponsored · Advertise</Link>
        </div>
      </div>
    </section>
  );
}
